import { showLoading, hideLoading } from 'react-redux-loading-bar'
import configData from '../config/config';
import * as types from './actionTypes'

export const getPointsRaceStartList = (raceCode) => (dispatch) => {
  dispatch(showLoading());
  return configData().then((config) => {
    return new Promise((resolve, reject) => fetch(`${config.API_URL}/api/PointsRace/GetStartList/${raceCode}`)
      .then(async (data) => {
        if (data.ok) {
          return data.json();
        }
        const error = await data.json();
        throw error;
      }).then((response) => {
        dispatch(getPointRacesStartListSuccess(response));
        dispatch(hideLoading());
        resolve();
      }).catch((error) => {
        dispatch(hideLoading());
        reject(error);
        console.log(error);
      }));
  });
}
export function getPointRacesStartListSuccess(pointsRaceStartList) {
  return { type: types.pointsRace.GET_POINTSRACESTARTLIST_SUCCESS, pointsRaceStartList };
}

export const getPointsRaceResults = (raceCode) => (dispatch) => {
  dispatch(showLoading());
  return configData().then((config) => {
    return new Promise((resolve, reject) => fetch(`${config.API_URL}/api/PointsRace/GetResults/${raceCode}`)
      .then(async (data) => {
        if (data.ok) {
          return data.json();
        }
        const error = await data.json();
        throw error;
      }).then((response) => {
        dispatch(getPointRacesResultsSuccess(response));
        dispatch(hideLoading());
        resolve();
      }).catch((error) => {
        dispatch(hideLoading());
        reject(error);
        console.log(error);
      }));
  });
}
export function getPointRacesResultsSuccess(pointsRaceResultsList) {
  return { type: types.pointsRace.GET_POINTSRACERESULTS_SUCCESS, pointsRaceResultsList };
}

export const getPointSprints = (raceCode) => (dispatch) => {
  dispatch(showLoading());
  return configData().then((config) => {
    return new Promise((resolve, reject) => fetch(`${config.API_URL}/api/PointsRace/GetSprints/${raceCode}`)
      .then(async (data) => {
        if (data.ok) {
          return data.json();
        }
        const error = await data.json();
        throw error;
      }).then((response) => {
        dispatch(getPointSprintsSuccess(response));
        dispatch(hideLoading());
        resolve();
      }).catch((error) => {
        dispatch(hideLoading());
        reject(error);
        console.log(error);
      }));
  });
}
export function getPointSprintsSuccess(pointsSprintList) {
  return { type: types.pointsRace.GET_POINTSRACESPRINTS_SUCCESS, pointsSprintList };
}
